import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
    ShipmentIntakeDraft,
    ShipmentIntakePricing,
    ShipmentIntakeReadiness,
    ShipmentIntakeRequest,
    ShipmentIntakeResponse,
    ShipmentIntakeRoutePreview,
    ShipmentIntakeWarehouseItemOption
} from './models/intake/shipment-intake.model';

@Injectable({
    providedIn: 'root'
})
export class ShipmentIntakeService {

    private readonly apiUrl = `${environment.restApiUrl}shipment-intake`;

    constructor(private http: HttpClient) {}

    createDraft(request: ShipmentIntakeRequest): Observable<ShipmentIntakeDraft> {
        return this.http.post<ShipmentIntakeDraft>(`${this.apiUrl}/drafts`, request);
    }

    updateDraft(draftId: number, request: ShipmentIntakeRequest): Observable<ShipmentIntakeDraft> {
        return this.http.put<ShipmentIntakeDraft>(`${this.apiUrl}/drafts/${draftId}`, request);
    }

    getDraft(draftId: number): Observable<ShipmentIntakeDraft> {
        return this.http.get<ShipmentIntakeDraft>(`${this.apiUrl}/drafts/${draftId}`);
    }

    submit(request: ShipmentIntakeRequest): Observable<ShipmentIntakeResponse> {
        return this.http.post<ShipmentIntakeResponse>(`${this.apiUrl}/submit`, request);
    }

    getShipment(shipmentId: number): Observable<ShipmentIntakeResponse> {
        return this.http.get<ShipmentIntakeResponse>(`${this.apiUrl}/shipments/${shipmentId}`);
    }

    searchWarehouseItems(filters?: {
        keyword?: string;
        crmClientId?: number;
        crmAccountId?: number;
        uomId?: number;
    }): Observable<ShipmentIntakeWarehouseItemOption[]> {
        let params = new HttpParams();
        if (filters?.keyword?.trim()) params = params.set('keyword', filters.keyword.trim());
        if (filters?.crmClientId != null) params = params.set('crmClientId', filters.crmClientId);
        if (filters?.crmAccountId != null) params = params.set('crmAccountId', filters.crmAccountId);
        if (filters?.uomId != null) params = params.set('uomId', filters.uomId);
        return this.http.get<ShipmentIntakeWarehouseItemOption[]>(`${this.apiUrl}/warehouse-items`, { params });
    }

    ratePreview(request: ShipmentIntakeRequest): Observable<ShipmentIntakePricing> {
        return this.http.post<ShipmentIntakePricing>(`${this.apiUrl}/rate-preview`, request);
    }

    routePreview(request: ShipmentIntakeRequest): Observable<ShipmentIntakeRoutePreview> {
        return this.http.post<ShipmentIntakeRoutePreview>(`${this.apiUrl}/route-preview`, request);
    }

    readinessCheck(request: ShipmentIntakeRequest): Observable<ShipmentIntakeReadiness> {
        return this.http.post<ShipmentIntakeReadiness>(`${this.apiUrl}/readiness-check`, request);
    }
}
